var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V10H2.66667V8.5H5.33333V10H8V0H0ZM2.13333 6.5H1.06667V5.5H2.13333V6.5ZM2.13333 5H1.06667V4H2.13333V5ZM2.13333 3.5H1.06667V2.5H2.13333V3.5ZM2.13333 2H1.06667V1H2.13333V2ZM3.73333 6.5H2.66667V5.5H3.73333V6.5ZM3.73333 5H2.66667V4H3.73333V5ZM3.73333 3.5H2.66667V2.5H3.73333V3.5ZM3.73333 2H2.66667V1H3.73333V2ZM5.33333 6.5H4.26667V5.5H5.33333V6.5ZM5.33333 5H4.26667V4H5.33333V5ZM5.33333 3.5H4.26667V2.5H5.33333V3.5ZM5.33333 2H4.26667V1H5.33333V2ZM6.93333 6.5H5.86667V5.5H6.93333V6.5ZM6.93333 5H5.86667V4H6.93333V5ZM6.93333 3.5H5.86667V2.5H6.93333V3.5ZM6.93333 2H5.86667V1H6.93333V2Z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardCompany);
export default __webpack_public_path__ + "static/media/card-company.01de9607920fa4d6fde3edb895930a12.svg";
export { ForwardRef as ReactComponent };